import React from "react";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";

import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SettingIcon from "@mui/icons-material/Settings";

import SNETFooter from "shared/dist/components/SNETFooter";
import VerticalTabs from "shared/dist/components/VerticalTabs";
import Header from "../Components/Header";
import { FooterData } from "./footerContent";
import { GlobalRoutes } from "../GlobalRouter/Routes";

import { useStyles } from "./styles";

const withDashboardMenu = (Component) => {
    const ComponentWithDashboardMenu = (props) => {
        const orgUuid = useSelector((state) => state.organization.uuid);

        const getTabRoute = (route) => {
            return orgUuid ? route : GlobalRoutes.LOGIN.path;
        };

        const upperTabs = [
            {
                icon: <HomeIcon />,
                title: "My AI Apps",
                href: getTabRoute(GlobalRoutes.SERVICES.path.replace(":orgUuid", orgUuid)),
                openInNewTab: false,
            },
            {
                icon: <GroupIcon />,
                title: "Teams & Access",
                href: getTabRoute(GlobalRoutes.INVITE_MEMBERS.path.replace(":orgUuid", orgUuid)),
                openInNewTab: false,
            },
            /*{
        icon: <ShowChartIcon />,
        title: "App Analytics",
      },
      {
        icon: <AttachMoneyIcon />,
        title: "Sales & Trends",
      },
      {
        icon: <DashboardIcon />,
        title: "Financial Reports",
      },*/
        ];

        const lowerTabs = [
            // {
            //     icon: <AccountBalanceIcon />,
            //     title: "Wallet Account",
            //     href: GlobalRoutes.WALLET_ACCOUNT.path,
            //     openInNewTab: false,
            // },
            {
                icon: <SettingIcon />,
                title: "Settings",
                href: getTabRoute(GlobalRoutes.USER_PROFILE.path),
                openInNewTab: false,
            },
        ];

        const classes = useStyles();

        return (
            <Box>
                <Header />
                <Box>
                    <VerticalTabs upperTabs={upperTabs} lowerTabs={lowerTabs} />
                    <Box
                        className={`${classes.componentsContainer} ${classes.dashboardContainers}`}
                    >
                        <Component {...props} />
                    </Box>
                </Box>
                <SNETFooter data={FooterData} />
            </Box>
        );
    };

    return ComponentWithDashboardMenu;
};

export default withDashboardMenu;
